module.exports = __webpack_public_path__ + "static/media/phone-company.ca232ac9.png";